import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Rfc} from "../../models/request";

/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider
{
    
    private rfc: Rfc;
    private rfcId: any;
    readonly PENDING: string = "PENDING";
    
    constructor()
    {
        console.log('Hello DataProvider Provider');
    }
    
    getRfc(): Rfc
    {
        return this.rfc
    }
    
    getRfcId(): any
    {
        return this.rfcId;
    }
    
    setRfcId(rfcId)
    {
        this.rfcId = rfcId;
    }
    
    setRfc(rfc: Rfc)
    {
        this.rfc = Object.assign({}, rfc);
    }
    
    validateRfc(rfc: Rfc)
    {
        try
        {
            let rfcStatus = rfc.rfcStatus || "";
            return rfc && rfc.rfcId && (rfcStatus.toUpperCase() == this.PENDING);
        }
        catch (e)
        {
            return false;
        }
        
    }
}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts